import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const EXPERIMENT_I18N_NAMESPACE =
  '@mc/next/experiments/pen-7562_v1_cm_promo_discount_guarantee'

export const i18nInstance = registerI18nResources({
  namespace: EXPERIMENT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
